// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3115":"bc70f11a","3824":"bc70f11a","9553":"58297519"}[chunkId] + ".chunk.css";
};